/* eslint-disable */
// @ts-nocheck
import {API_DOC_META, customTitle} from "../../../core-web/constants";
import Image from "next/image";
import React from "react";
import cs from "classnames";
import {ArrowRightIcon} from "@heroicons/react/outline";
import Link from "next/link";
import fs from "fs";
import matter from "gray-matter";
import Navigation from "../../../core-web/components/landing/molecules/Navigation";
import {WebsiteLayout} from "../../../core-web/components/landing/WebsiteLayout";
import {PageHead} from "../../../core-web/components/core/templates/PageHead";
import Footer from "../../../core-web/components/landing/molecules/Footer";


const Description = ({children}) => {
    return <p className={""}>
        {children}
    </p>
}

const ImageContainer = ({children, classNames}: { children: any, classNames?: string }) => {
    return <div className={"flex justify-center"}>
        <div
            className={cs("max-w-[300px] p-4 md:max-w-[700px] rounded shadow mx-1 overflow-hidden my-12", classNames)}>
            {children}
        </div>
    </div>
}


const Article = ({posts}) => {


  return <PageHead title={customTitle("How to create email from Notion page")}
                   description={"Learn how to create emails from Notion page. Send emails directly from Notion. Utilize notion email templates."}>
    <WebsiteLayout>
      <Navigation/>


      <h1 className={"text-4xl font-bold py-4 mt-12"}>How to create an email in Notion</h1>

      <ImageContainer classNames={"p-0 bg-blue-500 my-0 mb-8"}>
        <Image src={"/images/guides/create-email/hero.png"}
               width={800}
               height={600}
               alt={"Convert notion page to email - Illustration"}
               layout={"intrinsic"}/>
      </ImageContainer>

      <Description>
        Email is the most popular form of communication these days, and the way you format your letters can make
        a huge difference in their effectiveness. Creating visually appealing letters can be a difficult task
        due to formatting challenges.
        Advanced formatting with colors, images, gifs, tables, and columns is not so standard.

      </Description>
      <Description>
        <Link href={"/"} legacyBehavior><a className={"text-blue-500"}>Using Notion to create emails </a></Link>
        is an easy way to make them look creative and stylish without complex tools.
      </Description>

      <Description>
        This article will show you how to use Notion formatting options to create an email that will stand out.
      </Description>

      <h2 className={"text-2xl font-medium py-4"}>
        <span className={"text-blue-500 font-bold pr-2"}>1.</span>
        Create and format email in the Notion
      </h2>
      <Description>
        The Notion is a writing app for many people that has replaced Microsoft Word or Google Documents.
        It has all the features you need to create professional-looking documents, and it's much easier to use.
      </Description>
      <Description>
        Let's try and create an email in Notion.


      </Description>
      <Description>
        Our goal is to write an email with a weekly update for our reading club. We need to provide suggestions
        for the upcoming month with information for readers such as new
        members and books, suggested books to read, and book scores.
      </Description>
      <Description>
        It's essential to keep our emails concise. Let's start with a simple email structure:
        <ul className={"list-disc list-inside px-4 py-4 space-y-2"}>
          <li>
            Introduction and some general info
          </li>
          <li>
            Atomic Habits - book description and link
          </li>
          <li>
            Zero to one - book description and link
          </li>
        </ul>


        <ImageContainer>
          <Image src={"/images/guides/create-email/book-club-update-one.png"}
                 width={1138 / 3}
                 height={1462 / 3}
                 alt={"Notion page with email template"}
                 layout={"intrinsic"}/>
        </ImageContainer>

      </Description>
      <Description>
        The page looks good, but we definitely can improve it by utilizing extensive formatting options
        available in Notion.

      </Description>
      <Description>
        Let's apply additional styling to the page to interest our readers:

        <ul className={"list-disc list-inside px-4 py-4 space-y-2"}>
          <li>
            Add color headings with different block colors for headings
          </li>
          <li>
            Attach book images to show the cover
          </li>
          <li>
            Add book rating to the notion page to help people understand the general feedback about the
            book.
          </li>
        </ul>


        <ImageContainer>
          <Image src={"/images/guides/create-email/book-club-update-two.png"}
                 width={1150 / 3}
                 height={1548 / 3}
                 alt={"Notion page with email template and additional formatting"}
                 layout={"intrinsic"}/>
        </ImageContainer>

        Much better! The last step, although crucial, is to make the notion <b>page public</b>.
        Move the toggle to make the page public.

        <ImageContainer>
          <Image src={"/images/guides/create-email/share.png"}
                 width={658 / 2}
                 height={330 / 2}
                 alt={"Notion page with email template and additional formatting"}
                 layout={"intrinsic"}/>

        </ImageContainer>


      </Description>

      <Description>
        After finishing formatting the page - you can remove public access to the page and make it private
        again.
      </Description>

      <h2 className={"text-2xl font-medium py-4"}>
        <span className={"text-blue-500 font-bold pr-2"}>2.</span>

        Convert the notion page to the email with NotionSender
      </h2>
      <Description>Now we need to transform our page into an actual email. At this stage, it's essential to review
        the final result and make sure the formatting looks flawless. You can go back any time and make any
        necessary
        changes.

      </Description>

      <Description> To convert the notion page to email, we will use the NotionSender app. We need to copy our
        notion page URL and paste it into the NotionSender app. Make sure that your page is public. It's
        essential; otherwise, NotionSender won't be able to process the page.

      </Description>

      <Description>
        After we paste the notion page URL to the input field, the preview will automatically generate and show
        on the right side of the screen.
        Here, we also can adjust rendering options like page alignment, title, and icon appearance. After the
        notion page is converted, we can play with the configuration and review the final result.
      </Description>

      <ImageContainer classNames={"bg-gray-100"}>
        <Image src={"/images/guides/create-email/convert-preview-1.png"}
               width={2994}
               height={1700}
               alt={"Convert notion page to email - NotionSender UI"}
               layout={"intrinsic"}/>

      </ImageContainer>


      <Description>
        Once you are happy with the result, let's see how to send the email. NotionSender allows you to
        receive email results
        from the notion page directly in your inbox.
      </Description>
      <Description>
        If you want to receive the result - write your address in
        the input field and press the "Send" button. NotionSender will send it shortly to your address.
      </Description>
      <ImageContainer classNames={"bg-gray-100"}>
        <Image src={"/images/guides/create-email/convert-preview-2.png"}
               width={2994}
               height={1700}
               alt={"Convert notion page to email - NotionSender UI"}
               layout={"intrinsic"}/>

      </ImageContainer>


      <h2 className={"text-2xl font-medium py-4"}>
        <span className={"text-blue-500 font-bold pr-2"}>3.</span>
        Sending notion email to other users
      </h2>
      <Description>
        At this stage, you have already received the email and can customize and send it to the other people.
        Let's navigate to the mailing client and check the result.
      </Description>

      <ImageContainer classNames={"p-1"}>
        <Image src={"/images/guides/create-email/email-preview-1.png"}
               width={532 / 2}
               height={1170 / 2}
               alt={"Notion email preview."}
               layout={"intrinsic"}/>

      </ImageContainer>

      <Description>
        Looks awesome!
      </Description>

      <Description>
        The styling looks similar to the Notion, and media files like images and gifs are displayed correctly.
        Now we can customize it, add some text, and send it!

      </Description>

      <Description>
        We will use the "forward" option in the menu to use the existing content. When
        pressing forward, it's essential to:

        <ul className={"list-disc list-inside px-4 py-4 space-y-2"}>
          <li>
            Remember that you can change anything here; you can adjust any text or style
          </li>
          <li>
            Change the subject from "FWD:"
          </li>
          <li>
            Remove the default forward prefix
          </li>
        </ul>
      </Description>


      <div className={"md:flex justify-center items-center"}>
        <div>
          <ImageContainer classNames={"p-0"}>
            <Image src={"/images/guides/create-email/email-forward-1.png"}
                   width={532 / 2}
                   height={1170 / 2}
                   alt={"Notion email preview."}
                   layout={"intrinsic"}/>
          </ImageContainer>

        </div>
        <div className={"invisible md:visible px-8"}>
          <ArrowRightIcon className={"h-12 w-12 text-blue-500"}/>
        </div>

        <div>
          <ImageContainer classNames={"p-0"}>
            <Image src={"/images/guides/create-email/email-forward-2.png"}
                   width={532 / 2}
                   height={1170 / 2}
                   alt={"Notion email preview."}
                   layout={"intrinsic"}/>
          </ImageContainer>
        </div>
      </div>

      <Description>
        When everything is done and polished, write the recipient's address and send them to your address.
      </Description>


      <h2 className={"text-2xl font-medium py-4"}>Conclusion</h2>
      <Description>This article explained how to create emails from the notion page.
        It's an excellent opportunity for writers and Notion users to improve the quality of the emails you
        write and deliver.
      </Description>

      <Description>
        Click here to <Link href={"/create"} legacyBehavior><a className={"text-blue-500"}>create email from notion
        page</a></Link>
      </Description>


      <div className={"text-xl text-center font-medium my-8"}>More articles</div>

      <div className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 p-4 mb-8'>
        {posts
          .sort(() => Math.random() - Math.random()).slice(0, 3)
          .map(({slug, frontmatter}) => (
            <div
              key={slug}
              className='border border-gray-200 m-2 rounded-xl shadow-lg overflow-hidden flex flex-col'
            >
              <Link href={`/blog/post/${slug}`} legacyBehavior>
                <a>
                  <Image
                    width={650}
                    height={450}
                    alt={frontmatter.title}
                    src={`/${frontmatter.socialImage}`}
                  />
                  <div className='p-4'>{frontmatter.title}</div>
                </a>
              </Link>
            </div>
          ))}
      </div>


      <Footer/>
    </WebsiteLayout>
  </PageHead>


}

export default Article


export async function getStaticProps() {

    const files = fs.readdirSync('content/blog');
    const posts = files.map((fileName) => {
        const slug = fileName.replace('.md', '');
        const readFile = fs.readFileSync(`content/blog/${fileName}`, 'utf-8');
        const {data: frontmatter} = matter(readFile);
        return {
            slug,
            frontmatter,
        };
    });

    return {
        props: {
            posts: posts
        },
    };
}
